<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { ref } from 'vue';
import { useClassStore, useSignalRStore } from '../../stores';
import { ClassStudentInfo, StudentChangeGroup } from '../../types/class';
import Button from '../General/Button.vue';

const { studentIds, approve = false } = defineProps<{ studentIds: number[], approve?: boolean }>()
const emit = defineEmits<{ update: [] }>()

const signalr = useSignalRStore()
const classStore = useClassStore()
const studentsFiltered = classStore.selectedClassDetails?.students?.filter(student => studentIds.includes(student.id)) || []
const studentsCloned = ref<ClassStudentInfo[]>(JSON.parse(JSON.stringify(studentsFiltered)))

function handleSetStudentGroup(studentIndex: number, groupId: number) {
    if (!studentsCloned.value[studentIndex]) return;
    if (studentsCloned.value[studentIndex].group_id === groupId) {
        studentsCloned.value[studentIndex].group_id = null
        return
    }
    studentsCloned.value[studentIndex].group_id = groupId
}

function handleAddStudentConfirm() {
    const studentChangeGroups = studentsCloned.value.map<StudentChangeGroup>(student => {
        return {
            studentId: student.id,
            username: student.username,
            groupId: student.group_id
        }
    })
    signalr.teacherChangeGroup(studentChangeGroups, approve)
    emit('update')
}

const { t } = useI18n()
</script>

<template>
    <div class="rounded-lg bg-neutral-100 py-3 px-5 flex justify-between mb-3">
        <div class="font-bold">{{ t(TEXT.student_name) }}</div>
        <div class="font-bold">{{ t(TEXT.group) }}</div>
    </div>
    <div v-for="(student, studentIndex) in studentsCloned"
        class="rounded-lg bg-neutral-100 py-3 px-5 flex flex-wrap items-center justify-between gap-2 mb-3">
        <div>
            <strong>{{ student.full_name }}</strong> ({{ student.username }})
        </div>
        <div class="flex flex-wrap ml-auto gap-3">
            <Button v-for="group in classStore.studentGroups" color="info" class="shrink-0 grow"
                :class="{ 'opacity-40': student.group_id !== group.id }"
                @click="handleSetStudentGroup(studentIndex, group.id)">
                {{ group.name }}
            </Button>
        </div>
    </div>
    <div class="py-3 px-5">
        <Button color="success" class="mx-auto" @click="handleAddStudentConfirm">
            {{ t(TEXT.confirm) }}
        </Button>
    </div>
</template>